const s = {
  SHORT_DATETIME: {
    year: "numeric",
    day: "numeric",
    month: "short",
    hour: "numeric",
    minute: "numeric"
  },
  SHORT_DATETIME_SECONDS: {
    year: "numeric",
    day: "numeric",
    month: "short",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  },
  SHORT_DATETIME_WEEKDAY: {
    year: "numeric",
    day: "numeric",
    month: "short",
    weekday: "short",
    hour: "numeric",
    minute: "numeric"
  },
  SHORT_DATE: {
    year: "numeric",
    day: "numeric",
    month: "short"
  },
  LONG_DATETIME: {
    year: "numeric",
    day: "numeric",
    month: "long",
    hour: "numeric",
    minute: "numeric"
  },
  LONG_DATETIME_WEEKDAY: {
    year: "numeric",
    day: "numeric",
    month: "long",
    weekday: "short",
    hour: "numeric",
    minute: "numeric"
  },
  LONG_DATE: {
    year: "numeric",
    day: "numeric",
    month: "long"
  },
  TIME: {
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  },
  SHORT_TIME: {
    hour: "numeric",
    minute: "numeric"
  }
}, m = {
  LONG: { unitDisplay: "long" },
  SHORT: { unitDisplay: "short" },
  NARROW: { unitDisplay: "narrow" }
}, u = {
  LONG: { month: "long" },
  SHORT: { month: "short" }
}, a = {
  LONG: { weekday: "long" },
  SHORT: { weekday: "short" }
}, l = {
  US: "en-us"
}, h = {
  DateFormat: s,
  UnitFormat: m,
  MonthFormat: u,
  WeekdayFormat: a,
  Locale: l,
  getLocalisedWeekDays(e = 1, t = 7) {
    const r = /* @__PURE__ */ new Date(), n = r.getDay(), i = [];
    e = this.getLocale().toLocaleLowerCase() === "en-us" ? 0 : 1;
    for (let o = 0; o < t; o = o + 1) {
      const c = n - o - e;
      i.push({
        fullName: new Intl.DateTimeFormat(this.getLocale(), a.LONG).format(
          (/* @__PURE__ */ new Date()).setDate(r.getDate() - c)
        ),
        shortName: new Intl.DateTimeFormat(this.getLocale(), a.SHORT).format(
          (/* @__PURE__ */ new Date()).setDate(r.getDate() - c)
        )
      });
    }
    return i;
  },
  getLocalisedMonths(e, t = 12) {
    const r = [];
    for (let n = 0; n < t; n = n + 1)
      r.push(
        new Intl.DateTimeFormat(this.getLocale(), e).format(new Date(1970, n, 1))
      );
    return r;
  },
  isBrowserLocale(e) {
    return this.getBrowserLocale().toLocaleLowerCase() === e;
  },
  getBrowserLocale() {
    return navigator.language;
  },
  getLocale() {
    return this.locale || this.getBrowserLocale();
  },
  setLocale(e) {
    this.locale = e;
  },
  setTimeZone(e) {
    this.timezone = e;
  },
  getTimeZone() {
    return this.timezone;
  },
  localiseNumber(e, t) {
    return Number.isNaN(e) ? "" : Intl.NumberFormat(this.getLocale(), t).format(e);
  },
  getLocalisedNumber(e, t) {
    return this.localiseNumber(e, t);
  },
  getLocalisedPercentage(e, t) {
    return this.localiseNumber(e, {
      ...t,
      style: "percent"
    });
  },
  getLocalisedCurrency(e, t = "EUR") {
    return this.localiseNumber(e, {
      currency: t,
      style: "currency"
    });
  },
  getLocalisedUnit(e, t, r) {
    return this.localiseNumber(e, {
      style: "unit",
      unit: t,
      ...r
    });
  },
  localiseDateTime(e, t = {}) {
    const r = {
      timeZone: this.getTimeZone(),
      ...t
    };
    return new Intl.DateTimeFormat(this.getLocale(), r).format(new Date(e));
  },
  getLocalisedDate(e, t) {
    return this.localiseDateTime(e, t);
  }
};
export {
  h as L
};
